"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _default = _interopRequireDefault(require("../locale/default"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var runtimeLocale = _objectSpread({}, _default.default.modal);
var localeList = [];
var generateLocale = function generateLocale() {
  return localeList.reduce(function (merged, locale) {
    return _objectSpread(_objectSpread({}, merged), locale);
  }, _default.default.modal);
};
/**
 * 在 LocaleProvider 中调用，更新Confirm国际化内容
 * @param {object} newLocale  //
 */
function changeConfirmLocale(newLocale) {
  if (newLocale) {
    var cloneLocale = _objectSpread({}, newLocale);
    localeList.push(cloneLocale);
    runtimeLocale = generateLocale();
    return function () {
      localeList = localeList.filter(function (locale) {
        return locale !== cloneLocale;
      });
      runtimeLocale = generateLocale();
    };
  }
  runtimeLocale = _objectSpread({}, _default.default.modal);
}
function getConfirmLocale() {
  return runtimeLocale;
}